/**
 * Reusable Variant Selector Module
 * Handles variant selection for both dropdown and button style selectors
 */
window.VariantSelector = (function() {
  
  // Private variables
  const instances = {};
  
  // Private methods
  function getVariantsForForm(formId) {
    const variantsElement = document.getElementById(`product-variants-${formId}`);
    if (!variantsElement) return [];
    
    try {
      return JSON.parse(variantsElement.textContent);
    } catch (error) {
      console.error('Error parsing product variants:', error);
      return [];
    }
  }
  
  function findVariantByOptions(variants, options) {
    return variants.find(variant => {
      return Object.keys(options).every(optionName => {
        // Check if variant has this option value
        const value = options[optionName];
        return variant.option1 === value || variant.option2 === value || variant.option3 === value;
      }) && variant.available;
    });
  }
  
  function updateVariantId(formId) {
    const instance = instances[formId];
    if (!instance) return;
    
    const variants = getVariantsForForm(formId);
    if (variants.length === 0) return;
    
    const currentSelections = {};
    
    // Get current selections for this form
    if (instance.selectorType === 'dropdown') {
      const selectors = document.querySelectorAll(`[data-form-id="${formId}"].variant-selector`);
      selectors.forEach(selector => {
        if (selector.value && selector.value !== '') {
          currentSelections[selector.dataset.optionName] = selector.value;
        }
      });
    } else if (instance.selectorType === 'buttons') {
      const containers = document.querySelectorAll(`[data-form-id="${formId}"].variant-buttons`);
      containers.forEach(container => {
        const selectedButton = container.querySelector('.variant-button.selected');
        if (selectedButton) {
          currentSelections[container.dataset.optionName] = selectedButton.dataset.optionValue;
        }
      });
    }
    
    // Find matching variant
    const matchingVariant = findVariantByOptions(variants, currentSelections);
    
    if (matchingVariant) {
      // Store variant ID for form submission
      instance.selectedVariantId = matchingVariant.id;
      
      // Update any hidden inputs or selectors
      const hiddenInput = document.querySelector(`[data-form-id="${formId}"].variant-id-input`);
      if (hiddenInput) {
        hiddenInput.value = matchingVariant.id;
      }
      
      // Update main size select if it exists (for backward compatibility)
      const mainSizeSelect = document.getElementById('size-select');
      if (mainSizeSelect && formId === 'main-product') {
        mainSizeSelect.dataset.variantId = matchingVariant.id;
      }
      
      // Trigger custom event for image updates, etc.
      document.dispatchEvent(new CustomEvent('variantChanged', {
        detail: { formId, variant: matchingVariant, selections: currentSelections }
      }));
    }
  }
  
  function initializeDropdown(formId) {
    const selectors = document.querySelectorAll(`[data-form-id="${formId}"].variant-selector`);
    
    selectors.forEach(selector => {
      // Add change event listener
      selector.addEventListener('change', () => updateVariantId(formId));
    });
  }
  
  function initializeButtons(formId) {
    const buttonContainers = document.querySelectorAll(`[data-form-id="${formId}"].variant-buttons`);
    
    buttonContainers.forEach(container => {
      const buttons = container.querySelectorAll('.variant-button');
      
      buttons.forEach(button => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          
          if (button.disabled) return;
          
          // Remove selected class from siblings
          buttons.forEach(btn => btn.classList.remove('selected'));
          
          // Add selected class to clicked button
          button.classList.add('selected');
          
          updateVariantId(formId);
        });
      });
    });
  }
  
  // Public API
  return {
    init: function(formId, selectorType = 'dropdown') {
      // Store instance configuration
      instances[formId] = {
        selectorType: selectorType,
        selectedVariantId: null
      };
      
      if (selectorType === 'dropdown') {
        initializeDropdown(formId);
      } else if (selectorType === 'buttons') {
        initializeButtons(formId);
      }
      
      // Initialize variant ID
      updateVariantId(formId);
    },
    
    getSelectedVariantId: function(formId) {
      const instance = instances[formId];
      return instance ? instance.selectedVariantId : null;
    },
    
    addToCart: function(formId, variantId = null, quantity = 1) {
      const selectedVariantId = variantId || this.getSelectedVariantId(formId);
      
      if (!selectedVariantId) {
        console.error('No variant selected for add to cart');
        return Promise.reject('No variant selected');
      }
      
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: selectedVariantId,
          quantity: quantity
        })
      })
      .then(response => response.json())
      .then(data => {
        console.log('Product added to cart:', data);
        
        // Update cart contents
        return fetch('/cart.js');
      })
      .then(response => response.json())
      .then(async cart => {
        // Use centralized cart update function for consistency
        if (window.updateCart) {
          console.log('🔄 VariantSelector using centralized updateCart');
          await window.updateCart(cart);
        } else {
          // Fallback to individual functions if updateCart is not available
          console.log('⚠️ VariantSelector using fallback cart update');
          if (window.updateMenuCart) window.updateMenuCart(cart);
          if (window.updateMainCart) window.updateMainCart(cart);
          if (window.updateCartCount) window.updateCartCount(cart.item_count);
        }
        
        // Open cart drawer if function exists
        if (window.toggleCartDrawer) window.toggleCartDrawer();
        
        return cart;
      });
    }
  };
})(); 